import { createUseStyles, useDarkMode } from '@glu/theming';
import React from 'react';
import classnames from 'classnames';
import styles from './GroupLabel.styles';

const useStyles = createUseStyles(styles);
interface Props {
  children?: string;
}

const GroupLabel = ({ children = '' }: Props) => {
  const classes = useStyles();
  const dark = useDarkMode();

  return (
    <div className={classnames(classes.root, { [classes.dark]: dark })} data-qa="group-label">
      {children}
    </div>
  );
};

export default GroupLabel;
